export default "__VITE_ASSET__B20kljEn__"